import { render, staticRenderFns } from "./SrButton.vue?vue&type=template&id=19eb52dc"
import script from "./SrButton.vue?vue&type=script&lang=js"
export * from "./SrButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports